<script setup>
import { RouterView } from 'vue-router';
import { onMounted } from 'vue';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';
import logInDevMode from '@/services/backend/logInDevMode';

// TODO: move cleanup call to cronjob
//  this will call a clean up method on every visit.
//  This should be moved to a CRON job or similar later

const {
  callEndpoint,
  endpointData,
} = useCallEndPointWith('cleanup');

onMounted(async () => {
  await callEndpoint({
    method: 'POST',
  });

  logInDevMode('Cleanup called: ', endpointData);
});

</script>

<template>
  <div class="flex flex-col">
    <section>
      <RouterView />
    </section>
  </div>
</template>
